//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Иконка indeterminate состояния
 * ```vue live
 * <HseCheckboxIconIndeterminate />
 * ```
 */
var script = {
  name: 'HseCheckboxIconIndeterminate'
};

export default script;
